import type { TracedLayout } from '../traced';

/**
 * Layout traced from a top-down overview image of a well-known map (`cs_dust2_radar.png`) by tools/trace-map.py:
 * `#` wall, `.` floor, `c` low cover, run-length encoded (`12#` = twelve walls). Cells are 0.5 m; the longest side is 80.0 m.
 * The image itself is not in the repository.
 */
export const DUST_LAYOUT: TracedLayout = {
  cell: 0.5,
  width: 150,
  height: 160,
  spawns: [{ x0: 84.4, z0: 20.9, x1: 101.8, z1: 38.8 }, { x0: 38.8, z0: 138.7, x1: 71.2, z1: 153.0 }],
  sites: [{ x0: 18.3, z0: 9.2, x1: 32.9, z1: 24.9 }, { x0: 118.3, z0: 18.2, x1: 129.6, z1: 29.9 }],
  rows: [
    '4#6.3c137#',
    '4#6.3c137#',
    '4#6.2c.107#22.8#',
    '4#9.107#22.8#',
    '4#9.107#22.8#',
    '4#9.107#22.8#',
    '4#9.107#22.8#',
    '4#9.107#22.8#',
    '4#9.107#22.8#',
    '4#29.87#22.8#',
    '4#29.87#22.8#',
    '4#29.87#22.8#',
    '4#29.87#22.8#',
    '4#29.59#13.2c36.7#',
    '4#29.59#13.3c35.7#',
    '4#40.49#50.7#',
    '4#40.49#50.7#',
    '4#40.49#50.7#',
    '4#40.49#50.7#',
    '4#40.49#50.7#',
    '4#66.23#50.7#',
    '4#67.13#59.7#',
    '4#67.13#59.7#',
    '4#67.13#59.7#',
    '4#67.13#59.7#',
    '4#67.13#59.7#',
    '2#12.3c54.13#59.7#',
    '2#12.4c53.13#59.7#',
    '2#12.4c53.12#60.7#',
    '2#12.3c54.11#.3c57.7#',
    '3#79.4c57.7#',
    '#82.3c63.#',
    '#83.c64.#',
    '#148.#',
    '#149.',
    '#149.',
    '#149.',
    '#149.',
    '#149.',
    '3#29.5#7.7#4.6#89.',
    '2#30.29#17.2c6.7#9.14#34.',
    '2#30.29#17.2c4.9#9.14#34.',
    '2#30.29#21.11#9.27#21.',
    '2#30.29#10.22#9.27#21.',
    '2#30.29#10.22#9.27#21.',
    '2#30.29#10.21#10.27#21.',
    '2#29.30#10.21#10.27#21.',
    '2#12.2c14.31#10.21#10.27#21.',
    '2#12.2c13.32#10.21#10.27#18.3#',
    '2#26.33#12.19#10.26#19.3#',
    '7#5.7#8.34#12.19#10.26#17.5#',
    '7#5.7#7.35#12.19#10.26#16.6#',
    '7#5.7#6.36#10.21#10.26#16.6#',
    '7#5.7#6.36#10.21#10.26#15.7#',
    '7#5.7#5.37#10.21#10.26#15.7#',
    '7#5.7#5.40#7.21#10.26#15.7#',
    '7#5.7#4.41#7.21#10.26#15.7#',
    '7#5.52#7.7#8.6#10.26#15.7#',
    '7#5.52#7.7#8.6#10.26#15.7#',
    '7#5.25#65.27#14.7#',
    '7#5.25#65.27#14.7#',
    '7#5.25#65.27#14.7#',
    '7#5.25#33.c31.27#14.7#',
    '6#6.25#33.c31.27#14.7#',
    '2#4c15.16#65.27#13.8#',
    '2#5c14.16#14.2c49.27#13.8#',
    '2#5c14.16#14.2c41.35#13.8#',
    '2#5c14.17#7.19#16.49#13.8#',
    '2#23.#8.#10.19#15.50#13.8#',
    '2#43.19#14.51#13.8#',
    '2#43.19#14.51#13.8#',
    '2#43.19#14.28#36.8#',
    '2#43.19#14.23#41.8#',
    '2#43.19#14.23#41.8#',
    '2#42.19#15.23#41.8#',
    '2#41.19#16.23#41.8#',
    '2#40.20#16.23#41.8#',
    '2#39.21#16.23#46.3#',
    '14#11.37#16.23#48.#',
    '14#12.36#16.23#48.#',
    '14#11.37#16.23#48.#',
    '18#6.38#16.23#48.#',
    '18#6.38#16.23#48.#',
    '18#6.39#15.23#48.#',
    '18#6.40#14.23#48.#',
    '18#6.40#14.23#48.#',
    '19#5.40#14.23#48.#',
    '19#5.40#14.24#8.6#33.#',
    '19#5.40#14.24#7.8#32.#',
    '19#5.35#19.24#10.6#31.#',
    '11#20.28#19.24#10.6#31.#',
    '11#20.28#19.24#10.6#31.#',
    '11#20.28#19.24#6.c3.6#31.#',
    '6#28.25#19.24#10.6#31.#',
    '6#29.24#19.24#10.6#31.#',
    '6#29.24#19.24#10.6#31.#',
    '6#29.24#20.23#10.6#31.#',
    '6#29.20#25.22#10.6#31.#',
    '6#29.20#57.6#31.#',
    '6#29.21#56.6#31.#',
    '6#29.21#55.7#31.#',
    '6#29.21#55.7#31.#',
    '6#30.20#55.7#31.#',
    '6#30.20#55.7#31.#',
    '6#30.20#54.8#11.#12.#6.#',
    '6#30.21#14.14#25.8#11.#12.8#',
    '6#30.21#13.16#25.7#11.#12.8#',
    '6#30.21#12.18#24.7#11.#12.8#',
    '6#30.21#12.18#24.7#11.#12.8#',
    '6#31.27#5.18#24.19#12.8#',
    '6#31.27#5.18#24.39#',
    '6#31.27#5.18#24.39#',
    '7#30.27#5.18#24.39#',
    '7#30.27#5.18#24.39#',
    '7#30.27#5.18#24.39#',
    '7#26.31#5.18#24.39#',
    '7#25.32#5.18#24.39#',
    '7#24.33#5.18#24.39#',
    '7#24.33#5.18#24.39#',
    '7#24.33#.c3.18#24.39#',
    '5#26.33#.c3.18#24.39#',
    '5#26.33#5.18#24.39#',
    '5#26.9#7.17#5.18#24.39#',
    '5#26.9#8.16#5.18#25.38#',
    '5#27.8#8.16#5.18#25.38#',
    '5#43.16#5.18#25.38#',
    '5#43.16#5.17#26.38#',
    '5#43.16#5.17#26.38#',
    '5#43.16#5.17#26.38#',
    '5#43.16#5.17#26.38#',
    '5#43.16#6.16#11.6#9.38#',
    '5#43.16#7.15#11.6#8.39#',
    '5#43.16#16.5#12.53#',
    '5#43.16#33.53#',
    '5#43.16#33.53#',
    '5#43.16#33.53#',
    '4#44.16#33.53#',
    '2#46.16#33.53#',
    '#47.16#33.53#',
    '99.51#',
    '100.50#',
    '100.50#',
    '100.50#',
    '100.50#',
    '100.50#',
    '100.50#',
    '100.50#',
    '100.50#',
    '100.50#',
    '100.50#',
    '100.50#',
    '100.50#',
    '100.50#',
    '100.50#',
    '90.60#',
    '16#74.60#',
    '71#19.60#',
    '71#19.60#',
    '71#19.60#',
    '71#19.60#',
  ],
};
